import { queryOptions, useQuery } from '@tanstack/react-query';

import { qcTemplatesApi } from '../api/workflows-api';

import { workflowKeys } from './workflow-keys';

export function qcTemplatesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: workflowKeys.qcList(storeId),
    queryFn: () => qcTemplatesApi.list(storeId),
  });
}

export function useQcTemplates(storeId: string) {
  return useQuery(qcTemplatesQueryOptions(storeId));
}
